import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class Sculpture1 extends DestroyableObstacle {
	static key = "Sculpture1";

	getDebrisParticleType(): ParticleType {
		return ParticleType.GREEN_DEBRIS;
	}

	static deserialize(data: any): Sculpture1 {
		const s = new Sculpture1(deserializeXY(data.xy));
		s.restoreBaseFields(data);
		return s;
	}
}
